import { NgIf } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-dashboard-block-layout",
  templateUrl: "./dashboard-block-layout.component.html",
  styleUrl: "./dashboard-block-layout.component.scss",
  imports: [NgIf],
})
export class DashboardBlockLayoutComponent {
  @Input()
  label: string;

  @Input()
  labelIcon: string;
}
